export default "__VITE_ASSET__BVXr6nu5__"